import _ from "lodash";
import { useState } from "react";
import {
  PersonAddAlt1 as PatientIcon,
  Share as ShareIcon,
  AddOutlined as AddOutlinedIcon,
} from "@mui/icons-material";
import {
  Fab,
  SpeedDial,
  SpeedDialAction,
  SvgIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate } from "../../../../utils/hooks";

const NewPatientButton = ({ direction, ...props }) => {
  const navigate = useNavigate();

  const addNow = () => {
    navigate("/patients/new");
  };

  const addNewLink = () => {
    navigate("/patients/new/link-self-registration");
  };

  const actions = [
    { icon: <PatientIcon />, name: "Agregar paciente", action: addNow },
    { icon: <ShareIcon />, name: "Link para pacientes", action: addNewLink },
  ];

  return (
    <>
      <SpeedDial
        FabProps={{
          sx: {
            backgroundColor: "secondaryGreen.main",
            "&:hover": { backgroundColor: "secondaryGreen.hover" },
          },
        }}
        ariaLabel="add-patient"
        icon={<AddOutlinedIcon />}
        direction={direction}
        sx={{ position: "absolute", top: 0, right: 0 }}
        {...props}
      >
        {_.map(actions, ({ icon, name, action }) => (
          <SpeedDialAction
            sx={{ "&:hover": { backgroundColor: "secondaryGreen.main" } }}
            key={name}
            icon={
              <Tooltip title={name} arrow placement="left">
                <SvgIcon
                  sx={{
                    color: "secondaryGreen.main",
                    "&:hover": { color: "text.white" },
                  }}
                >
                  {icon}
                </SvgIcon>
              </Tooltip>
            }
            onClick={action}
          />
        ))}
      </SpeedDial>
    <Typography
      variant="body1"
      sx={{
        color: "secondaryGreen.main",
        display: { xs: "none", sm: "block" },
        position: "fixed",
        bottom: "4rem",
        right: "8rem",
      }}
    >
      Nuevos Pacientes
    </Typography>
    </>
  );
};

export default NewPatientButton;
